import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, ModalBody, ModalFooter, Spinner, ModalHeader, Input, Modal, Button, Table } from 'reactstrap';
import moment from 'moment';
import { useSelector } from "react-redux";
import { Col, Row, Button as Btn, Modal as Mdl } from 'reactstrap';
import { selectValues} from '../../../utils/fc';
import Select from '../../Template/Input/Select';
import oikosApi from '../../../services/oikos';
import powerAppsApi from '../../../services/powerapps';
import qs from 'qs';
import { notifyError, notifySuccess } from '../../../utils/notify';
import { Box, IconButton, TextareaAutosize, Tooltip, Typography } from '@mui/material';
import { Add, Delete, Edit, MonetizationOn, PostAdd } from '@material-ui/icons';
import MaskedInput from '../../Template/Input/MaskedInput';
import MaterialReactTable from 'material-react-table';
import DatePicker from 'react-datepicker'
import currencyFormatter from '../../../utils/currencyFormatter';
import AddFiles from '../../Template/Files/AddFiles';
import ModalFormAddFornecedor from '../ModalFormAddFornecedor/ModalFormAddFornecedor';
import ModalFormEditFornecedor from '../ModalFormEditFornecedor/ModalFormEditFornecedor';
import {
  CONTR_FORN_STATUS_EM_APROVACAO,
  CONTR_FORN_STATUS_EM_ASSINATURA,
  needsContrFornApproval,
} from '../ModalFormContrForn/contrFornApprovalRules';
import {
  formatPgtoPrazoDiasDisplay,
  persistPgtoPrazoDias,
} from '../ModalFormContrForn/contrFornEntregaveisUtils';

const ModalFormContrFornEventos = ( props ) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditValorModalOpen, setIsEditValorModalOpen] = useState(false);
  const [selPfsFornecedor, setSelPfsFornecedor] = React.useState([]);
  const [selPjsFornecedor, setSelPjsFornecedor] = React.useState([]);
  const [selPfs, setSelPfs] = React.useState([]);
  const [selPjs, setSelPjs] = React.useState([]);
  const [selStatus, setSelStatus] = React.useState([]);
  const [selTipoContrato, setSelTipoContrato] = React.useState([]);
  const [selCentroDeCusto, setSelCentroDeCusto] = React.useState([]);
  const [selTiposDeMinuta, setSelTiposDeMinuta] = React.useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingSubmit, setLoadingSumbit] = useState(false);
  const [listaDotacoes, setListaDotacoes] = useState([]);
  const [listaParcelas, setListaParcelas] = React.useState([]);
  const [contrFornData, setContrFornData] = React.useState(props.contrFornData || {});
  const [selProdutos, setSelProdutos] = React.useState([]);
  const [editParcela, setEditParcela] = React.useState([]);
  const [indexToEdit, setIndexToEdit] = React.useState(null);
  const { user } = useSelector(state => state.auth);
  const [pageContrFornForm, setPageContrFornForm] = React.useState(1);
  const [filesContrForn, setFilesContrForn] = React.useState([]);
  const [listaParcelasIdsParaDeletar, setListaParcelasIdsParaDeletar] = React.useState([]);
  const [selOrcItems, setSelOrcItems] = React.useState([]);
  const [tasksFilhas, setTasksFilhas] = React.useState([]);
  const [taskMae, setTaskMae] = React.useState([]);
  const [valoresLimites, setValoresLimites] = React.useState([]);
  const autoOpenHandledRef = useRef(false);
  //const [contrFornEventos, setContrFornEventos] = React.useState([]);
  //const [bdros, setBdros] = React.useState([]);


  const filteredDotacoes = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    return listaDotacoes.filter(({ orcDot_data }) => {
      const [y, m] = orcDot_data.split("-").map(Number);
      const itemYM = y * 100 + m;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    listaDotacoes
  ]);

  const filteredValoresLimites = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    return valoresLimites.filter(({ mes }) => {
      const [y, m] = mes.split("-").map(Number);
      const itemYM = y * 100 + m;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    valoresLimites
  ]);

  /*
  const filteredEventos = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    return contrFornEventos.filter(({ contrFornEvento_dtPrev }) => {
      const [y, m] = contrFornEvento_dtPrev.split("-").map(Number);
      const itemYM = y * 100 + m;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    contrFornEventos
  ]);

  const filteredBdros = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    return bdros.filter(({ bdro_dtVenc, bdro_tabRef, bdro_tabId }) => {
      if (!bdro_dtVenc) {
        notifyError('Algum bordero não possui data de vencimento.');
        return false;
      }
      if (!bdro_tabRef && !bdro_tabId) {
        const [y, m] = bdro_dtVenc.split("-").map(Number);
        const itemYM = y * 100 + m;
        return itemYM >= startYM && itemYM <= endYM;
      }
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    contrFornEventos
  ]);

  const valorLimite = React.useMemo(() => {
    let somaDotacoes = 0;
    if (filteredDotacoes.length) {
      somaDotacoes = filteredDotacoes
        .reduce((acc, { orcDot_valor }) => acc + Number(orcDot_valor || 0), 0);
    }
    console.log('somaDotacoes', somaDotacoes);
    let somaJaAlocadoEventos = 0;
    if (filteredEventos.length) {
      somaJaAlocadoEventos = filteredEventos
        .reduce((acc, { contrFornEvento_vlr }) => acc + Number(contrFornEvento_vlr || 0), 0);
    }
    console.log('somaJaAlocadoEventos', somaJaAlocadoEventos);
    let somaJaAlocadoBdros = 0;
    if (filteredBdros.length) {
      somaJaAlocadoBdros = filteredBdros
        .reduce((acc, { bdro_vlr }) => acc + Number(bdro_vlr || 0), 0);
    }
    console.log('somaJaAlocadoBdros', somaJaAlocadoBdros);
    return Number((somaDotacoes - somaJaAlocadoEventos - somaJaAlocadoBdros).toFixed(2));
  }, [filteredDotacoes, filteredEventos, filteredBdros]);
  */

  const columnsParcelas = [
    {
      accessorKey: 'contrFornEvento_num',
      header: 'Número',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.contrFornEvento_num) {
          return row.contrFornEvento_num;
        } else {
          return 'Sem número';
        }
      },
    },
    {
      accessorKey: 'contrFornEvento_desc',
      header: 'Descrição',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.contrFornEvento_desc) {
          return row.contrFornEvento_desc;
        } else {
          return 'Sem Descrição';
        }
      },
    },
    {
      accessorKey: 'contrFornEvento_pgtoPrazoDias',
      header: 'Prazo (Dias)',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => formatPgtoPrazoDiasDisplay(row.contrFornEvento_pgtoPrazoDias),
    },
    {
      accessorKey: 'contrFornEvento_dtPrev',
      header: 'Data prev.',
      accessorFn: (row) => {
        if (row.contrFornEvento_dtPrev) {
          return moment(row.contrFornEvento_dtPrev, 'YYYY-MM-DD').toDate();
        } else {
          return null;
        }
      },
      size: 100,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.contrFornEvento_dtPrev) {
          return moment(cell.getValue()).format('DD/MM/YYYY')
        }
      }, // Format Date for display
    },
    {
      accessorKey: 'contrFornEvento_vlr',
      header: 'Valor',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.contrFornEvento_vlr) {
          return parseFloat(row.contrFornEvento_vlr).toFixed(2);
        } else {
          return '0.00';
        }
      },
      Cell: ({ cell, row }) => {
        const value = cell.getValue();
        return value ? `R$ ${parseFloat(value).toFixed(2).replace('.', ',')}` : 'Sem Valor';
      },
    },
    {
      header: 'Ações',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <Tooltip title="Excluir parcela">
          <IconButton
            aria-label="Excluir"
            color="error"
            onClick={() => {
              if (row.original.contrFornEvento_id) {
                setListaParcelasIdsParaDeletar([...listaParcelasIdsParaDeletar, row.original.contrFornEvento_id])
              }
              handleDeleteParcela(row.original.contrFornEvento_num);
            }}
          >
            <Delete style={{ width: '18px', height: '18px' }} />
          </IconButton>
        </Tooltip>
      ),
    }
  ]

  async function saveDocuments(files, contrFornRecord) {
    // Cria um registro na tabela de documentos para cada arquivo
    await Promise.all(files.map(async (file) => {
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: file.props.documentType.tpDocumento_id,
          documento_desc: `Contrato ${file.data.path}`,
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      const documentCreated = await oikosApi.post('/', documentBody)

      // Cria uma vinculação entre o documento (anexo) e o registro da minuta
      if (documentCreated.data[0].documento_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'contrForn',
            documentoVinc_tabId: contrFornRecord.contrForn_id,
          },
        }
        await oikosApi.post('/', vinculationBody)
      }

      // Faz upload do arquivo e registra na tabela 'arquivo'
      const formData = new FormData()
      formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'documento')
      formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
      formData.append('arquivo_desc', file.data.path)
      const fileUploadRes = await oikosApi.post('/', formData)
      console.tron.log('fileUploadRes', fileUploadRes)
    }))
  }

  function verificaDocumentoContrForn() {
    console.log(contrFornData.contrFornStatus_id)
    if(filesContrForn.length <= 0 && contrFornData.contrFornStatus_id !== 9) {
      notifyError('Campo de "Anexos complementares" vazio')
      return false;
    }
    if (filesContrForn.length > 0) {
      const filesSemTipo = filesContrForn.filter(file => !file.props.documentType);
      if (filesSemTipo.length > 0) {
        notifyError("Algum documento está sem Tipo");
        return false;
      }
    }
    return true;
  }

  function verificarSaldoMensalValido(listaDotacoes, listaParcelas) {
    for (const dotacao of listaDotacoes) {
      const monthRef = dotacao.orcDot_data.slice(0, 7); // 'YYYY-MM'

      // Soma todas as parcelas do mesmo mês
      const somaParcelasMes = listaParcelas
        .filter(parcela => parcela.contrFornEvento_dtPrev ? parcela.contrFornEvento_dtPrev.slice(0, 7) === monthRef : false)
        .reduce((acc, cur) => acc + Number(cur.contrFornEvento_vlr || 0), 0);

      const somaDotacoesMes = filteredDotacoes
        .filter(dotacao => dotacao.orcDot_data ? dotacao.orcDot_data.slice(0, 7) === monthRef : false)
        .reduce((acc, cur) => acc + Number(cur.orcDot_valor || 0), 0);

      // Compara
      const diferenca = (Number(Number(dotacao.orcDot_valor).toFixed(2))) - Number(somaParcelasMes.toFixed(2));

      if (diferenca < 0) {
        return false;
      }
    }

    return true;
  }

  const checkCamposObrigatorios = (parcela, counter) => {

    const camposObrigatorios = {
      contrFornEvento_desc: 'Descrição',
      contrFornEvento_num: 'Nº contrato',
      contrFornEvento_pgtoPrazoDias: 'Prazo',
      contrFornEvento_dtPrev: 'Data Prevista',
    }

    for (const campo of Object.keys(camposObrigatorios)) {
      if (!parcela[campo]) {
        notifyError(`O campo "${camposObrigatorios[campo]}" da parcela ${counter} é obrigatório.`)
        return false
      }
    }
    return true
  }

  function verificaDataVigencia() {
    if(new Date(contrFornData.contrForn_dtVigFim) < new Date(contrFornData.contrForn_dtVigIni)) {
      notifyError('Data de início da vigência é maior que data de fim.')
      return false;
    }

    const parcelasForaDoIntervaloDeVigencia = listaParcelas.filter(p => {
      console.log('new Date(p.contrFornEvento_dtPrev)', new Date(p.contrFornEvento_dtPrev));
      console.log('new Date(contrFornData.contrForn_dtVigFim)', new Date(contrFornData.contrForn_dtVigFim));
      console.log('new Date(contrFornData.contrForn_dtVigIni)', new Date(contrFornData.contrForn_dtVigIni));
      return (new Date(p.contrFornEvento_dtPrev) > new Date(contrFornData.contrForn_dtVigFim) || new Date(p.contrFornEvento_dtPrev) < new Date(contrFornData.contrForn_dtVigIni))
    });
    console.log(parcelasForaDoIntervaloDeVigencia);
    if(parcelasForaDoIntervaloDeVigencia.length > 0) {
      notifyError('Alguma parcela está com Data Prevista fora do intervalo de vigência do contrato.')
      return false;
    }

    return true;
  }

  const checkValorGlobalGeral = () => {
    const somaParcelas = listaParcelas.reduce((acc, parcela) => {
      return acc + (Number(parcela.contrFornEvento_vlr) || 0);
    }, 0);

    if (Number(Number(somaParcelas).toFixed(2)) > Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2))) {
      notifyError('A soma das parcelas não pode ser maior que o valor global do contrato.');
      return false;
    }
    if (Number(Number(somaParcelas).toFixed(2)) !== Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2))) {
      notifyError('A soma das parcelas deve ser igual ao valor global do contrato.');
      return false;
    }
    return true;
  }

  const getPossiveisFornecedores = async (pfTrue) => {
    try {
      if (!pfTrue) {
        const res = await selectValues('pj', 'pj_id', 'pj_razaosocial');

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjs(sortedFavs);

        return sortedFavs;

      } else {
        const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao');

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPfs(sortedFavs);

        return sortedFavs;

      }
    } catch (error) {
      console.error("Failed to fetch product details:", error);
    }
  };

  const fetchCentroDeCustoForSelect = async () => {
    try {
      let dataOrcRubr = {
        orcRubr_ativo: 1,
        orcRubr_mae: `!IN!(1, 2)`
      }

      const resTodosCentrosDeCustos = await selectValues('orcRubr', 'orcRubr_id', 'orcRubr_nome', dataOrcRubr);

      const sortedCentrosDeCustos = (resTodosCentrosDeCustos).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });

      setSelCentroDeCusto(sortedCentrosDeCustos);
    } catch (error) {
      console.error("Error fetching orcItems:", error);
      return [];
    }
  }

  const fetchTiposDeMinutaForSelect = async () => {
    try {
      setSelTiposDeMinuta(await selectValues('tpMinuta', 'tpMinuta_id', 'tpMinuta_nome'));
    } catch (error) {
      console.error("Error fetching Status:", error);
      return [];
    }
  }

  const fetchTasksRelacionadasAoContrForn = async () => {
    const dataTasks = {
      action: 'get',
      table: 'task',
      data: {
        task_tabId: contrFornData.contrForn_id,
        task_tabRef: 'contrForn',
      },
    };

    const res = await oikosApi.get(`/?${qs.stringify(dataTasks)}`);

    setTaskMae(res.data.find(t => !t.task_mae));

    setTasksFilhas(res.data.filter(t => t.task_mae));
  }

  const handleClickOpenModal = () => setIsModalOpen(true);
  const handleClickCloseModal = () => {setIsModalOpen(false); setPageContrFornForm(1);}

  const getOrcDots = async (orcItemId) => {
    console.log('orcItemId', orcItemId)
      const resOrcDots = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'orcDot',
        data: {
          orcItem_id: orcItemId,
          orcDot_ativo: 1
        }
      })}`)
      setListaDotacoes(resOrcDots.data);

      console.log('resOrcDots.data', resOrcDots.data)

      const resContrForns = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contrForn',
        data: {
          orcItem_id: orcItemId,
        }
      })}`)
      console.log('resContrForns', resContrForns.data);

      let txtContrForn_ids = ''
      for (let index = 0; index < resContrForns.data.length; index++) {
        const element = resContrForns.data[index];
        if (index < resContrForns.data.length - 1) {
          txtContrForn_ids = txtContrForn_ids + `${element.contrForn_id}, `
        } else {
          txtContrForn_ids = txtContrForn_ids + `${element.contrForn_id}`
        }
      }

      console.log('txtContrForn_ids', txtContrForn_ids)

      let resContrFornEventos = {data: []};

      if (resContrForns.data.length > 0) {
        resContrFornEventos = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'contrFornEvento',
          data: {
            contrForn_id: `!IN! (${txtContrForn_ids})`,
          }
        })}`);
      }

      setListaParcelas(resContrFornEventos.data.filter(ev => ev.contrForn_id === props.contrFornData.contrForn_id));

      /*

      setContrFornEventos(resContrFornEventos.data);

      const resBdros = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'bdro',
        data: {
          orcItem_id: orcItemId,
          bdro_ativo: 1,
        }
      })}`)
      console.log('resBdros', resBdros.data);
      setBdros(resBdros.data);
      */

      const verificaBody = {
        acao: 'verificar_disponibilidade_orcItem',
        orcItem_id: Number(orcItemId),
      }

      const res = await powerAppsApi.post('/', verificaBody, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })

      console.log('verificar_disponibilidade_orcItem', res.data)

      setValoresLimites(res.data);

      console.log('Valores limites:', res.data);
  };

  async function loadData() {
    setIsLoading(true);
    await getOrcDots(props.contrFornData.orcItem_id);
    fetchStatusForSelect();
    fetchTiposDeContratoForSelect();
    fetchPfsFornecedoresForSelect();
    fetchPjsFornecedoresForSelect();
    fetchCentroDeCustoForSelect();
    fetchPfsForSelect();
    fetchOrcItemsForSelect();
    fetchTasksRelacionadasAoContrForn();
    fetchTiposDeMinutaForSelect();
    setIsLoading(false);
  }

  useEffect(() => {
    if (!props.autoOpen) {
      autoOpenHandledRef.current = false;
      return;
    }
    if (autoOpenHandledRef.current) return;

    autoOpenHandledRef.current = true;
    const openModal = async () => {
      await loadData();
      handleClickOpenModal();
    };

    openModal();
  }, [props.autoOpen]);

  function handleAddParcela() {
    setListaParcelas(prev => [...prev, {contrFornEvento_desc: `Parcela ${prev.length + 1}`, contrFornEvento_vlr: 0, contrFornEvento_dtPrev: null, contrFornEvento_dtReal: null, contrFornEvento_num: prev.length + 1, contrForn_id: contrFornData.contrForn_id}]);
  }

  function handleDeleteParcela(contrFornEvento_num) {
    setListaParcelas((prev) => prev
    .filter((t) => t.contrFornEvento_num !== contrFornEvento_num)
    .map((p, i) => {
      const parcelaPattern = /^Parcela \d+$/; // matches "Parcela 1", "Parcela 2"...
      return {
        ...p,
        contrFornEvento_num: i + 1,
        contrFornEvento_desc: parcelaPattern.test(p.contrFornEvento_desc)
          ? `Parcela ${i + 1}`
          : p.contrFornEvento_desc,
      };
    }));
  }

  function handleNextPage(page) {
    console.log(page);
    if (page >= 2) return;
    return setPageContrFornForm(page + 1);
  }

  function handlePrevPage(page) {
    console.log(page);
    if (page <= 1) return;
    return setPageContrFornForm(page - 1);
  }

  const checkCamposObrigatoriosParcelas = (parcela, counter) => {
    const camposObrigatorios = {
      contrFornEvento_desc: 'Descrição',
      contrFornEvento_num: 'Nº contrato',
      contrFornEvento_pgtoPrazoDias: 'Prazo',
      contrFornEvento_dtPrev: 'Data',
    }

    for (const campo of Object.keys(camposObrigatorios)) {
      if (!parcela[campo]) {
        notifyError(`O campo "${camposObrigatorios[campo]}" da parcela ${counter} é obrigatório.`)
        return false
      }
    }
    return true
  }

  const handleDetailChange = (rowIndex, field, value) => {
    setListaParcelas(old =>
      old.map((item, idx) =>
        idx === rowIndex ? { ...item, [field]: value } : item
      )
    );
  };

  const fetchOrcItemsForSelect = async (centro_id) => {
    try {
      let dataOrcItems = {
        orcItem_ativo: 1,
        nivel2_id: centro_id,
      }

      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'viewRubr_OrcItem',
        fields: {
          orcItem_id: 'value',
          item_orcamentario: 'label'
        },
        data: dataOrcItems,
        order: 'label'
      })}`;

      const resp = await oikosApi.get(queryString);

      setSelOrcItems(resp.data);
    } catch (error) {
      console.error("Error fetching orcItems:", error);
      return [];
    }
  }

  function verificarValorGlobal() {
    // Convert start and end to Date objects (first day of month for simplicity)
    const startDate = new Date(contrFornData.contrForn_dtVigIni);
    const endDate = new Date(contrFornData.contrForn_dtVigFim);

    // Filter valoresLimites by comparing the months between start and end
    const valoresFiltrados = valoresLimites.filter(v => {
      const mesDate = new Date(`${v.mes}-01`); // convert "2025-09" → Date("2025-09-01")
      return mesDate >= startDate && mesDate <= endDate;
    });

    const somaValoresLimites = valoresFiltrados.reduce((acc,cur)=>{
      return Number(acc).toFixed(2) + Number(cur.disponivel).toFixed(2)
    }, 0)

    const somaParcelas = listaParcelas.reduce((acc,cur)=>{
      return Number(acc).toFixed(2) + Number(cur.contrFornEvento_vlr).toFixed(2)
    }, 0)
    console.log('somaParcelas', somaParcelas);
    console.log('somaValoresLimites', somaValoresLimites);
    console.log('contrFornData.contrForn_vlrGlobal', Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2)));
    if (Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2)) - somaParcelas > somaValoresLimites) {
      notifyError('Saldo insuficiente')
      return false;
    }
    return true;
  }

  function checkCamposObrigatoriosContrForn() {
    const camposObrigatorios = {
      contrForn_desc: 'Descrição',
      contrForn_parteTab: 'Tipo de contratado',
      contrForn_parteId: 'Contratado',
      contrForn_obj: 'Objeto',
      contrForn_vlrGlobal: 'Valor global',
      contrForn_dtVigIni: 'Data de início da vigência',
      contrForn_dtVigFim: 'Data de fim da vigência',
      contrFornTp_id: 'Tipo de contrato',
      contrForn_detalhamento: 'Detalhamento',
    }

    for (const campo of Object.keys(camposObrigatorios)) {
      if (!contrFornData[campo]) {
        notifyError(`O campo "${camposObrigatorios[campo]}" do contrato é obrigatório.`)
        return false
      }
    }
    return true
  }

  async function handleReenviarParaAprovacao() {
    const vlrGlobal = Number(contrFornData.contrForn_vlrGlobal) || 0;
    if (!needsContrFornApproval(vlrGlobal)) {
      await oikosApi.post('/', {
        action: 'update',
        table: 'contrForn',
        data: {
          contrForn_id: contrFornData.contrForn_id,
          contrFornStatus_id: CONTR_FORN_STATUS_EM_ASSINATURA,
        },
      });
      notifySuccess('Contrato não requer aprovação (valor abaixo de R$ 10.000). Status atualizado para Em assinatura.');
      setIsModalOpen(false);
      if (props.fetchContratosFornecedores) props.fetchContratosFornecedores();
      return;
    }

    let contratadoNome = '';
    if (contrFornData.contrForn_parteTab === 'pf') {
      contratadoNome = selPfsFornecedor.find(f => f.value === contrFornData.contrForn_parteId)?.label || '';
    } else if (contrFornData.contrForn_parteTab === 'pj') {
      contratadoNome = selPjsFornecedor.find(f => f.value === contrFornData.contrForn_parteId)?.label || '';
    }

    await oikosApi.post('/', {
      action: 'update',
      table: 'contrForn',
      data: {
        contrForn_id: contrFornData.contrForn_id,
        contrFornStatus_id: CONTR_FORN_STATUS_EM_APROVACAO,
      },
    });

    const postBodyTask = {
      action: 'insert',
      table: 'task',
      data: {
        task_tabRef: 'contrForn',
        task_tabId: contrFornData.contrForn_id,
        pf_id: user.pf_id,
        task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
        taskTp_id: 3,
        dpto_id: undefined,
        task_desc: `Aprovar contrato ${contrFornData.contrForn_num} ${contratadoNome}`,
        task_orientacao: 'Avalie o anexo desta tarefa. Após, clique em "Aprovar" ou "Rejeitar" de acordo com o seu julgamento',
      }
    };

    const responseTask = await oikosApi.post(`/`, postBodyTask);

    const centroDeCusto = Number(selOrcItems.filter(oi => oi.value === contrFornData.orcItem_id)[0]?.nivel2_id);

    if (selOrcItems.length > 0 && [13, 14].includes(centroDeCusto)) {
      await oikosApi.post(`/`, {...postBodyTask, data: { ...postBodyTask.data, pf_id: 2, task_mae: responseTask.data[0].task_id}});
    } else if (selOrcItems.length > 0 && !([13, 14].includes(centroDeCusto))) {
      await oikosApi.post(`/`, {...postBodyTask, data: { ...postBodyTask.data, pf_id: 1, task_mae: responseTask.data[0].task_id}});
    }

    notifySuccess('Contrato reenviado para aprovação.');
    setIsModalOpen(false);
    if (props.fetchContratosFornecedores) props.fetchContratosFornecedores();
  }

  async function handleResubmitContract(contrFornRecord) {
    setLoadingSumbit(true);

    const verificaListaEventos = listaParcelas.length > 0;
    if (!verificaListaEventos) {
      notifyError('É necessário cadastrar pelo menos uma parcela.');
      return setLoadingSumbit(false);
    }

    const isSaldoValido = verificarSaldoMensalValido(filteredDotacoes, listaParcelas);
    if (!isSaldoValido) {
      notifyError("Há pelo menos um mês com gasto superior ao valor limite!");
      return setLoadingSumbit(false);
    }

    const verificaCamposObrigatoriosContrForn = checkCamposObrigatoriosContrForn();
    if (!verificaCamposObrigatoriosContrForn) return setLoadingSumbit(false);

    const checkValor = checkValorGlobalGeral();
    if (!checkValor) return setLoadingSumbit(false);

    const checkValorGlobal = verificarValorGlobal();
    if (!checkValorGlobal) return setLoadingSumbit(false);

    const checkDocumento = verificaDocumentoContrForn();
    if (!checkDocumento) return setLoadingSumbit(false);

    const checkDataVigencia = verificaDataVigencia();
    if (!checkDataVigencia) return setLoadingSumbit(false);

    if (filesContrForn.length > 0) {
      const filesSemTipo = filesContrForn.filter(file => !file.props.documentType);
      if (filesSemTipo.length > 0) {
        notifyError("Algum documento está sem Tipo");
        return setLoadingSumbit(false);
      }
      await saveDocuments(filesContrForn, contrFornRecord)
    }

    let checkCampos = true;
    let counter = 1;
    for (const parcela of listaParcelas) {
      if (!checkCamposObrigatorios(parcela, counter)) {
        checkCampos = false;
        break;
      }
      counter++;
    }
    if (!checkCampos) return;
    try {

      Promise.all((listaParcelasIdsParaDeletar.map(async (parcelaId) => {
        const parcelaBody = {
          action: 'delete',
          table: 'contrFornEvento',
          data: {
            contrFornEvento_id: parcelaId,
          },
        }
        console.tron.log('parcelaBodyDelete', parcelaBody);
        const parcelaDeleted = await oikosApi.post('/', parcelaBody);
      })))

      Promise.all((listaParcelas.map(async (parcela) => {
        if (parcela.contrFornEvento_id) {
          const parcelaBody = {
            action: 'update',
            table: 'contrFornEvento',
            data: {
              contrFornEvento_id: parcela.contrFornEvento_id || undefined,
              contrForn_id: parcela.contrForn_id || undefined,
              contrFornEvento_num: parcela.contrFornEvento_num || undefined,
              contrFornEvento_desc: parcela.contrFornEvento_desc || undefined,
              contrFornEvento_pgtoPrazoDias: persistPgtoPrazoDias(parcela.contrFornEvento_pgtoPrazoDias),
              contrFornEvento_dtPrev: parcela.contrFornEvento_dtPrev ? moment(parcela.contrFornEvento_dtPrev).format('YYYY-MM-DD') : undefined,
              contrFornEvento_dtReal: parcela.contrFornEvento_dtReal ? moment(parcela.contrFornEvento_dtReal).format('YYYY-MM-DD') : undefined,
              contrFornEvento_aprovNecessita: 1,
              contrFornEvento_aprovLiberado: Number(parcela.contrFornEvento_aprovLiberado) ? 1 : 0,
              contrFornEvento_obs: parcela.contrFornEvento_obs || undefined,
              contrFornEvento_usuarioCria: user.pf_id,
              contrFornEvento_usuarioMod: user.pf_id,
              contrFornEvento_vlr: parcela.contrFornEvento_vlr || 0,
            },
          }
          console.tron.log('parcelaBodyUpdated', parcelaBody);
          const parcelaUpdated = await oikosApi.post('/', parcelaBody);
        } else {
          const parcelaBody = {
            action: 'insert',
            table: 'contrFornEvento',
            data: {
              contrForn_id: parcela.contrForn_id || undefined,
              contrFornEvento_num: parcela.contrFornEvento_num || undefined,
              contrFornEvento_desc: parcela.contrFornEvento_desc || undefined,
              contrFornEvento_pgtoPrazoDias: persistPgtoPrazoDias(parcela.contrFornEvento_pgtoPrazoDias),
              contrFornEvento_dtPrev: parcela.contrFornEvento_dtPrev ? moment(parcela.contrFornEvento_dtPrev).format('YYYY-MM-DD') : undefined,
              contrFornEvento_dtReal: parcela.contrFornEvento_dtReal ? moment(parcela.contrFornEvento_dtReal).format('YYYY-MM-DD') : undefined,
              contrFornEvento_aprovNecessita: 1,
              contrFornEvento_aprovLiberado: parcela.contrFornEvento_aprovLiberado ? 1 : 0,
              contrFornEvento_obs: parcela.contrFornEvento_obs || undefined,
              contrFornEvento_usuarioCria: user.pf_id,
              contrFornEvento_usuarioMod: user.pf_id,
              contrFornEvento_vlr: parcela.contrFornEvento_vlr || 0,
            },
          }
          console.tron.log('parcelaBodyCreated', parcelaBody);
          const parcelaCreated = await oikosApi.post('/', parcelaBody);
        }
      })))

      const vlrGlobal = Number(contrFornData.contrForn_vlrGlobal) || 0;
      const requiresApproval = needsContrFornApproval(vlrGlobal);
      const contrFornStatusId = requiresApproval
        ? CONTR_FORN_STATUS_EM_APROVACAO
        : CONTR_FORN_STATUS_EM_ASSINATURA;

      const postBody = {
        action: 'update',
        table: 'contrForn',
        data: {
          contrForn_id: contrFornData.contrForn_id,
          contrForn_desc: contrFornData.contrForn_desc,
          contrForn_num: contrFornData.contrForn_num,
          contrForn_obs: contrFornData.contrForn_obs,
          contrForn_obj: contrFornData.contrForn_obj,
          orcItem_id: contrFornData.orcItem_id,
          contrForn_dtVigFim: contrFornData.contrForn_dtVigFim,
          contrForn_dtVigIni: contrFornData.contrForn_dtVigIni,
          contrForn_vlrGlobal: contrFornData.contrForn_vlrGlobal,
          contrFornStatus_id: contrFornStatusId,
          contrFornTp_id: contrFornData.contrFornTp_id,
          contrForn_usuarioCria: user.pf_id,
          contrForn_usuarioMod: user.pf_id,
        }
      };
      console.log(postBody)
      const response = await oikosApi.post(`/`, postBody);
      setContrFornData({...response.data[0]})

      console.log('tasksFilhas', tasksFilhas);

      if (requiresApproval) {
        if (tasksFilhas?.length > 0) {
          await Promise.all(tasksFilhas.map(async task => {
            const postBodyTask = {
              action: 'update',
              table: 'task',
              data: {
                task_id: task.task_id,
                task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
                taskStatus_id: 1
              }
            };
            console.log('postBodyTask', postBodyTask)
            const responseTask = await oikosApi.post(`/`, postBodyTask);

            console.log(responseTask);
          }))
        } else {
          let contratadoNome = '';
          if (contrFornData.contrForn_parteTab === 'pf') {
            contratadoNome = selPfsFornecedor.find(f => f.value === contrFornData.contrForn_parteId)?.label || '';
          } else if (contrFornData.contrForn_parteTab === 'pj') {
            contratadoNome = selPjsFornecedor.find(f => f.value === contrFornData.contrForn_parteId)?.label || '';
          }
          const postBodyTask = {
            action: 'insert',
            table: 'task',
            data: {
              task_tabRef: 'contrForn',
              task_tabId: response.data[0].contrForn_id,
              pf_id: user.pf_id,
              task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
              taskTp_id: 3,
              dpto_id: undefined,
              task_desc: `Aprovar contrato ${response.data[0].contrForn_num} ${contratadoNome}`,
              task_orientacao: 'Avalie o anexo desta tarefa. Após, clique em "Aprovar" ou "Rejeitar" de acordo com o seu julgamento',
            }
          };

          const responseTask = await oikosApi.post(`/`, postBodyTask);

          const centroDeCusto = Number(selOrcItems.filter(oi => oi.value === contrFornData.orcItem_id)[0]?.nivel2_id);

          if (selOrcItems.length > 0 && [13, 14].includes(centroDeCusto)) {
            await oikosApi.post(`/`, {...postBodyTask, data: { ...postBodyTask.data, pf_id: 2, task_mae: responseTask.data[0].task_id}});
          } else if (selOrcItems.length > 0 && !([13, 14].includes(centroDeCusto))) {
            await oikosApi.post(`/`, {...postBodyTask, data: { ...postBodyTask.data, pf_id: 1, task_mae: responseTask.data[0].task_id}});
          }
        }

        notifySuccess('Contrato reenviado para aprovação')
      } else {
        notifySuccess('Contrato atualizado. Não requer aprovação (valor abaixo de R$ 10.000). Status Em assinatura.')
      }
      setIsModalOpen(false);
      props.fetchContratosFornecedores(); // Refresh the list after creation
    } catch (error) {
      console.error("Error creating contrato de fornecedor:", error);
    } finally {
      setLoadingSumbit(false);
    }
  }

  const fetchStatusForSelect = async () => {
    try {
      setSelStatus(await selectValues('contrFornStatus', 'contrFornStatus_id', 'contrFornStatus_nome'));
    } catch (error) {
      console.error("Error fetching Status:", error);
      return [];
    }
  }

  const fetchTiposDeContratoForSelect = async () => {
    try {
      setSelTipoContrato(await selectValues('contrFornTp', 'contrFornTp_id', 'contrFornTp_nome'));
    } catch (error) {
      console.error("Error fetching Tipos:", error);
      return [];
    }
  }

  const fetchPfsFornecedoresForSelect = async () => {
    try {
      const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_fornecedor: 1, pf_ativo: 1});
      const sortedFavs = (res).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setSelPfsFornecedor(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pfs:", error);
      return [];
    }
  }

  const fetchPfsForSelect = async () => {
    try {
      const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_ativo: 1});
      const sortedFavs = (res).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setSelPfs(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pfs for select:", error);
      return [];
    }
  }

  const fetchPjsFornecedoresForSelect = async () => {
    try {
      const res = await selectValues('pj', 'pj_id', 'pj_razaosocial', {pj_fornecedor: 1, pj_ativo: 1});
      const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjsFornecedor(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pjs:", error);
      return [];
    }
  }

  const getFornecedores = async (pfTrue) => {
    try {
      if (!pfTrue) {
        const res = await selectValues('pj', 'pj_id', 'pj_razaosocial', {pj_fornecedor: 1});

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjsFornecedor(sortedFavs);

        return sortedFavs;

      } else {
        const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_fornecedor: 1});

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPfsFornecedor(sortedFavs);

        return sortedFavs;

      }
    } catch (error) {
      console.error("Failed to fetch product details:", error);
    }
  };

  React.useEffect(() => {
    if (!contrFornData.centroDeCustoRubr_id) return; // Prevent running without centroDeCustoRubr_id
    if(contrFornData.centroDeCustoRubr_id) {
      fetchOrcItemsForSelect(contrFornData.centroDeCustoRubr_id);
    }
  }, [contrFornData.centroDeCustoRubr_id]);

  return (
    <>
      <IconButton
        onClick={async () => {
          console.log('contrFornData', contrFornData);
          await loadData();
          handleClickOpenModal();
        }}
      >
        {isLoading ? <Spinner /> : <MonetizationOn />}
      </IconButton>

      <Modal
        isOpen={isModalOpen}
        toggle={handleClickCloseModal}
        size="xl"
      >
        <ModalHeader>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Edição de contrato de fornecedor
          </Typography>
        </ModalHeader>
        <ModalBody>
          {pageContrFornForm === 1 && listaParcelas.length > 0 &&
            <Row>
              <Col sm={3}>
                <FormGroup>
                  <Label>
                    Centro de custo
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione um item"
                    value={contrFornData.centroDeCustoRubr_id ? selCentroDeCusto.filter(x => (x.value === contrFornData.centroDeCustoRubr_id)) : null}
                    options={selCentroDeCusto}
                    onChange={(e) => {
                      setContrFornData({ ...contrFornData, centroDeCustoRubr_id: e.value, orcItem_id: null });
                      setListaDotacoes([]);
                      console.log(e.value);
                      //getOrcDots(e.value);
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={9}>
                <FormGroup>
                  <Label>
                    Item orçamentário
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione um item"
                    disabled
                    value={contrFornData.orcItem_id ? selOrcItems.filter(x => (x.value === contrFornData.orcItem_id)) : null}
                    options={contrFornData.centroDeCustoRubr_id ? selOrcItems : []}
                    onChange={(e) => {
                      setContrFornData({ ...contrFornData, orcItem_id: e.value });
                      console.log(e.value);
                      getOrcDots(e.value);
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={12}>
                <FormGroup>
                  <Label>
                    Descrição do objeto
                  </Label>
                  <Input
                    type="text"
                    placeholder="Descrição do objeto..."
                    value={contrFornData.contrForn_desc || ''}
                    onChange={(e) => setContrFornData({ ...contrFornData, contrForn_desc: e.target.value })}
                  />
                </FormGroup>
              </Col>

              <Col sm={12}>
                <Label>
                  Objeto do contrato
                </Label>
                <TextareaAutosize
                  placeholder='Descreva o objeto do contrato'
                  margin="dense"
                  id="input_obs"
                  name="input_obs"
                  variant="standard"
                  className='mb-3 p-1'
                  style={{ width: '100%', height: '100px' }}
                  value={contrFornData.contrForn_obj || null}
                  onChange={(e) => setContrFornData({ ...contrFornData, contrForn_obj: e.target.value })}
                />
              </Col>

              <Col sm={12}>
                <FormGroup>
                  <Label>
                    Campo de detalhamento do serviço
                  </Label>
                  <TextareaAutosize
                    placeholder='Detalhamento do serviço...'
                    margin="dense"
                    id="input_obs"
                    name="input_obs"
                    variant="standard"
                    value={contrFornData.contrForn_detalhamento || null}
                    className='mb-3 p-1'
                    style={{ width: '100%', height: '100px' }}
                    onChange={(e) => setContrFornData({ ...contrFornData, contrForn_detalhamento: e.target.value })}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Modelo de minuta
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Modelo de minuta"
                    value={contrFornData.tpMinuta_id ? selTiposDeMinuta.filter(x => (x.value === contrFornData.tpMinuta_id)) : null}
                    options={selTiposDeMinuta}
                    onChange={(e) => setContrFornData({ ...contrFornData, tpMinuta_id: e.value })}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Tipo de contratado
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="PF ou PJ"
                    value={[{value: 'pf', label: 'Pessoa Física'}, {value: 'pj', label: 'Pessoa Jurídica'}].filter(x => (x.value === contrFornData.contrForn_parteTab))}
                    options={[{value: 'pf', label: 'Pessoa Física'}, {value: 'pj', label: 'Pessoa Jurídica'}]}
                    onChange={(e) => setContrFornData({ ...contrFornData, contrForn_parteTab: e.value })}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <div className="d-flex">
                    <Label>
                      Contratado
                    </Label>
                    <ModalFormAddFornecedor
                      contrFornData={contrFornData}
                      setContrFornData={setContrFornData}
                      getPossiveisFornecedores={getPossiveisFornecedores}
                      isPf={contrFornData.contrForn_parteTab === 'pf'}
                      setSelPfsFornecedor={setSelPfsFornecedor}
                      setSelPjsFornecedor={setSelPjsFornecedor}
                      fetchPfsFornecedoresForSelect={fetchPfsFornecedoresForSelect}
                      fetchPjsFornecedoresForSelect={fetchPjsFornecedoresForSelect}
                    />
                    {
                      contrFornData.contrForn_parteId &&
                      <ModalFormEditFornecedor
                        contrFornData={contrFornData}
                        contrForn_parteId={contrFornData.contrForn_parteId}
                        setContrFornData={setContrFornData}
                        getPossiveisFornecedores={getPossiveisFornecedores}
                        isPf={contrFornData.contrForn_parteTab === 'pf'}
                        setSelPfsFornecedor={setSelPfsFornecedor}
                        setSelPjsFornecedor={setSelPjsFornecedor}
                        fetchPfsFornecedoresForSelect={fetchPfsFornecedoresForSelect}
                        fetchPjsFornecedoresForSelect={fetchPjsFornecedoresForSelect}
                      />
                    }
                  </div>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione um contratado"
                    value={contrFornData.contrForn_parteTab === 'pf' ? selPfsFornecedor.filter(x => (x.value === contrFornData.contrForn_parteId)) : selPjsFornecedor.filter(x => (x.value === contrFornData.contrForn_parteId))}
                    options={!contrFornData.contrForn_parteTab ? [] : contrFornData.contrForn_parteTab === 'pf' ? selPfsFornecedor : selPjsFornecedor}
                    onChange={(e) => setContrFornData({ ...contrFornData, contrForn_parteId: e.value })}
                  />
                </FormGroup>
              </Col>

              {/*
              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Data da assinatura
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={contrFornData.contrForn_dtAssin ? moment(contrFornData.contrForn_dtAssin).toDate() : null}
                    onChange={date => {
                      if (date) {
                        setContrFornData({ ...contrFornData, contrForn_dtAssin: moment(date).format('YYYY-MM-DD') });
                      } else {
                        setContrFornData({ ...contrFornData, contrForn_dtAssin: null });
                      }
                    }}
                  />
                </FormGroup>
              </Col>
              */}

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Data Início Vigência
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={contrFornData.contrForn_dtVigIni ? moment(contrFornData.contrForn_dtVigIni).toDate() : null}
                    onChange={date => {
                      if (date) {
                        setContrFornData({ ...contrFornData, contrForn_dtVigIni: moment(date).format('YYYY-MM-DD') });
                      } else {
                        setContrFornData({ ...contrFornData, contrForn_dtVigIni: null });
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Data Fim Vigência
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={contrFornData.contrForn_dtVigFim ? moment(contrFornData.contrForn_dtVigFim).toDate() : null}
                    onChange={date => {
                      if (date) {
                        setContrFornData({ ...contrFornData, contrForn_dtVigFim: moment(date).format('YYYY-MM-DD') })
                      } else {
                        setContrFornData({ ...contrFornData, contrForn_dtVigFim: null });
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Tipo de contrato
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione um item"
                    value={selTipoContrato ? selTipoContrato.filter(x => (x.value === contrFornData.contrFornTp_id)) : null}
                    options={selTipoContrato}
                    onChange={(e) => setContrFornData({ ...contrFornData, contrFornTp_id: e.value })}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Valor
                  </Label>
                  <MaskedInput
                    unmask
                    inputRef={el => {const inputVlrGlobal = el}}
                    mask="R$ num"
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 1000000000,
                      },
                    }}
                    lazy={false}
                    value={String(contrFornData.contrForn_vlrGlobal)}
                    onAccept={value => { setContrFornData({ ...contrFornData, contrForn_vlrGlobal: value }) }}
                  />
                </FormGroup>
              </Col>

              <Col sm={8}>
                {
                  (filteredDotacoes.length > 0 && contrFornData.orcItem_id && contrFornData.contrForn_dtVigIni && contrFornData.contrForn_dtVigFim) ?
                    <div className='mb-2'>
                      <span>Valor disponível: </span>
                      <span style={{fontWeight: 'bold'}}>{
                        currencyFormatter.format(filteredValoresLimites.reduce((acc,cur)=>{
                          return Number(acc) + Number(cur.disponivel)
                        }, 0))
                      }</span><br />
                      <span>Soma de dotações para esse item: </span>
                      <span style={{fontWeight: 'bold'}}>{
                        currencyFormatter.format(filteredDotacoes.reduce((acc,cur)=>{
                          return Number(acc) + Number(cur.orcDot_valor)
                        }, 0))
                      }</span><br />
                      <span>Já alocado: </span>
                      <span style={{fontWeight: 'bold'}}>{
                        currencyFormatter.format(
                          filteredDotacoes.reduce((acc,cur)=>{
                          return Number(acc) + Number(cur.orcDot_valor)
                        }, 0) -
                          filteredValoresLimites.reduce((acc,cur)=>{
                          return Number(acc) + Number(cur.disponivel)
                        }, 0))
                      }</span>
                    </div>
                  : (contrFornData.orcItem_id && (!contrFornData.contrForn_dtVigIni || !contrFornData.contrForn_dtVigFim)) ?
                    <span style={{fontWeight: 'bold'}} >Selecione uma data de início e fim de vigência</span>:
                  <></>
                }
              </Col>

              <Col sm={12}>
                <Label>
                  Observação
                </Label>
                <TextareaAutosize
                  placeholder='Observações...'
                  margin="dense"
                  id="input_obs"
                  name="input_obs"
                  variant="standard"
                  className='mb-3 p-1'
                  style={{ width: '100%', height: '100px' }}
                  value={contrFornData.contrForn_obs || null}
                  onChange={(e) => setContrFornData({ ...contrFornData, contrForn_obs: e.target.value })}
                />
              </Col>

              <Col sm={12}>
                <FormGroup>
                  <Label>
                    Anexos complementares
                  </Label>
                  <AddFiles
                    multiple={true}
                    //accept={['.pdf']}
                    files={filesContrForn} // Pass state
                    onFilesChange={setFilesContrForn} // Update state
                  />
                </FormGroup>
              </Col>

              {filteredValoresLimites && filteredValoresLimites.length > 0 &&
                <>
                  <div className="table-responsive">
                    <Table striped bordered>
                      <thead>
                        <tr>
                          <th></th>
                          {filteredDotacoes?.length > 0 && filteredDotacoes.map((dotacao, index) => {
                            const date = new Date(`${dotacao.orcDot_data}T12:00:00`);
                            const month = date.toLocaleDateString('pt-BR', { month: 'short' }); // ex: 'abr.'
                            const year = date.getFullYear();

                            // Remove o ponto final e deixa a primeira letra maiúscula
                            const formattedMonth = month.replace('.', '').charAt(0).toUpperCase() + month.slice(1, 3);

                            return (
                              <th key={index} style={{ minWidth: '10vw' }}>
                                {`${formattedMonth}/${year}`}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {filteredDotacoes?.length > 0 ? (
                          <>
                            <tr>
                              <th>Orçado</th>
                              {filteredDotacoes.map((_, index) => {
                                return (
                                  <td key={`prov-${index}`}>
                                    {currencyFormatter.format(filteredDotacoes[index].orcDot_valor)}
                                  </td>
                                )
                              })}
                            </tr>
                            <tr>
                              <th>Já alocado</th>
                              {filteredValoresLimites.map((_, index) => {
                                const monthRef = filteredDotacoes[index].orcDot_data.slice(0, 7); // 'YYYY-MM'
                                const sumForMonthDotacoes = filteredDotacoes
                                  .filter(dotacao => dotacao.orcDot_data ? dotacao.orcDot_data.slice(0, 7) === monthRef : false)
                                  .reduce((acc, curr) => acc + Number(curr.orcDot_valor || 0), 0);
                                const sumForMonthParcelas = listaParcelas
                                  .filter(parcela => parcela.contrFornEvento_dtPrev ? parcela.contrFornEvento_dtPrev.slice(0, 7) === monthRef : false)
                                  .reduce((acc, curr) => acc + Number(curr.contrFornEvento_vlr || 0), 0);
                                return (
                                  <td key={`prov-${index}`}>
                                    {currencyFormatter.format(sumForMonthDotacoes - Number(sumForMonthParcelas || 0))}
                                  </td>
                                )
                              })}
                            </tr>
                            <tr>
                              <th>Valor disponível</th>
                              {filteredValoresLimites.map((_, index) => {
                                return (
                                  <td key={`prov-${index}`}>
                                    {currencyFormatter.format(filteredValoresLimites[index].disponivel)}
                                  </td>
                                )
                              })}
                            </tr>
                            <tr>
                              <th>Soma dos eventos</th>
                              {filteredDotacoes.map((dotacao, index) => {
                                const monthRef = dotacao.orcDot_data.slice(0, 7); // 'YYYY-MM'

                                const sumForMonth = listaParcelas
                                  .filter(parcela => parcela.contrFornEvento_dtPrev ? parcela.contrFornEvento_dtPrev.slice(0, 7) === monthRef : false)
                                  .reduce((acc, curr) => acc + Number(curr.contrFornEvento_vlr || 0), 0);

                                return (
                                  <td key={`val-${index}`}>
                                    {currencyFormatter.format(sumForMonth)}
                                  </td>
                                );
                              })}
                            </tr>
                            {/*
                            <tr>
                              <th>Diferença</th>
                              {filteredDotacoes.map((dotacao, index) => {
                                const monthRef = dotacao.orcDot_data.slice(0, 7); // 'YYYY-MM'

                                const somaParcelas = listaParcelas
                                  .filter(parcela => parcela.contrFornEvento_dtPrev ? parcela.contrFornEvento_dtPrev.slice(0, 7) === monthRef : false)
                                  .reduce((acc, cur) => acc + Number(cur.contrFornEvento_vlr || 0), 0);

                                console.log('filteredValoresLimites[index]', filteredValoresLimites[index]);
                                console.log('filteredValoresLimites', filteredValoresLimites);

                                const diferenca = Number(dotacao.orcDot_valor - filteredValoresLimites[index].disponivel) - somaParcelas;
                                const color = diferenca < 0 ? 'red' : 'green';

                                return (
                                  <td key={`dif-${index}`} style={{ color }}>
                                    {currencyFormatter.format(diferenca)}
                                  </td>
                                );
                              })}
                            </tr>
                            */}
                          </>
                        ) : <></>
                        }
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>Saldo disponível</td>
                          <td style={{
                            color:
                              (
                                filteredDotacoes.reduce((prev, cur, index) => {
                                  return Number(cur.orcDot_valor)+prev
                                }, 0) -
                                listaParcelas.reduce((prev, cur, index) => {
                                  return Number(cur.contrFornEvento_vlr)+prev
                                }, 0)
                              ) < 0 ? 'red' : 'green'
                          }}>
                            {
                              currencyFormatter.format(
                                filteredDotacoes.reduce((prev, cur, index) => {
                                  return Number(cur.orcDot_valor)+prev
                                }, 0) -
                                listaParcelas.reduce((prev, cur, index) => {
                                  return Number(cur.contrFornEvento_vlr)+prev
                                }, 0)
                              )
                            }
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </div>
                  <Col sm={12}>
                    <MaterialReactTable
                      columns={columnsParcelas}
                      data={listaParcelas}
                      initialState={{
                        density: 'compact',
                        expanded: {}, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 50 },
                        sorting: [{ id: 'contrFornEvento_num', desc: false }], //sort by state by default
                      }}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(listaParcelas.length > 50)}
                      muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '[class="MuiSvgIcon-root"]': {width: '24px !important'}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                      renderTopToolbarCustomActions={() => (
                        <Box marginLeft="auto">
                          <IconButton style={{backgroundColor: "success"}} onClick={handleAddParcela}>
                            <Add/>
                          </IconButton>
                        </Box>
                      )}
                      muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                      muiTablePaginationProps={{
                        sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                        labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                        rowsPerPageOptions: [50, 100],
                      }}
                      positionPagination='top'
                      muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                      enableRowExpansion={true}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          '.MuiSvgIcon-root': {fontSize: "18px"},
                          fontSize: '12px',
                          fontWeight: 'normal', // Remove bold text in the header
                          padding: '8px', // Adjust padding to reduce white space
                        },
                      }}
                      renderDetailPanel={({ row }) => {
                        const p = row.original;
                        return (
                          <Box p={2}>
                            <Row>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="desc">Descrição</Label>
                                  <Input
                                    id="desc"
                                    value={p.contrFornEvento_desc ?? ''}
                                    onChange={e =>
                                      handleDetailChange(row.index, 'contrFornEvento_desc', e.target.value)
                                    }
                                  />
                                </FormGroup>
                              </Col>

                              <Col sm={4}>
                                <FormGroup>
                                  <Label>
                                    Data Prevista p/ realização
                                  </Label>
                                  <DatePicker
                                    placeholderText="__/__/_____"
                                    locale="pt-BR"
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy"
                                    dropdownMode="select"
                                    popperContainer={()=><></>}
                                    selected={p.contrFornEvento_dtPrev ? moment(p.contrFornEvento_dtPrev).toDate() : null}
                                    onChange={date => handleDetailChange(row.index, 'contrFornEvento_dtPrev', moment(date).format('YYYY-MM-DD'))}
                                  />
                                </FormGroup>
                              </Col>

                              <Col md={4}>
                                <FormGroup>
                                  <Label for="prazo">{'Prazo (dias)'}</Label>
                                  <Input
                                    type='number'
                                    id="prazo"
                                    value={p.contrFornEvento_pgtoPrazoDias ?? ''}
                                    onChange={e =>
                                      handleDetailChange(row.index, 'contrFornEvento_pgtoPrazoDias', e.target.value)
                                    }
                                  />
                                </FormGroup>
                              </Col>

                              <Col md={4}>
                                <FormGroup>
                                  <Label for="vlr">Valor</Label>
                                  <MaskedInput
                                    unmask
                                    mask="num"
                                    blocks={{
                                      num: {
                                        mask: Number,
                                        scale: 2,
                                        signed: false,
                                        thousandsSeparator: '.',
                                        radix: ',',
                                        min: 0,
                                      },
                                    }}
                                    value={p.contrFornEvento_vlr ? String(p.contrFornEvento_vlr) : null}
                                    onAccept={value =>
                                      handleDetailChange(row.index, 'contrFornEvento_vlr', Number(value))
                                    }
                                  />
                                </FormGroup>
                              </Col>

                              {/*
                              <Col md={12}>
                                <FormGroup>
                                  <div className='d-flex justify-content-between align-items-center'>
                                    <div className='d-flex'>
                                      <span className='mr-2'>Necessidade evidência de aprovação?</span>
                                      <input
                                        type="checkbox"
                                        placeholder="Necessidade evidência de aprovação?"
                                        checked={p.contrFornEvento_aprovNecessita === 1}
                                        onChange={e => {
                                          if (e.target.checked) {
                                            return handleDetailChange(row.index, 'contrFornEvento_aprovNecessita', 1);
                                          }
                                          return handleDetailChange(row.index, 'contrFornEvento_aprovNecessita', 0);
                                        }}
                                        style={{ padding: '0.5rem', borderRadius: '4px', border: '1px solid #ccc' }}
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </Col>
                              */}
                            </Row>
                          </Box>
                        );
                      }}
                    />
                  </Col>
                </>
              }
            </Row>
          }
        </ModalBody>
        <ModalFooter>
          <Button disabled={loadingSubmit} onClick={handleClickCloseModal}>Fechar</Button>
          {contrFornData.contrFornStatus_id === 8 ?
            <Button disabled={loadingSubmit} color="primary" onClick={() => handleReenviarParaAprovacao(contrFornData)}>Reenviar para aprovação</Button> :
            <Spinner />
          }
          {contrFornData.contrFornStatus_id === 9 ?
            <Button disabled={loadingSubmit} color="primary" onClick={() => handleResubmitContract(contrFornData)}>Reenviar para aprovação</Button> :
            <Spinner />
          }
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ModalFormContrFornEventos;
